import React from 'react';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';

const withQnAPagination = Component => props => {
  const { dispatchMetrics, fetchMore } = props;

  const onPaginationClick = nextOffset => {
    dispatchMetrics('event:track', {
      category: 'qna-pdp',
      action: 'ver-mais-perguntas',
    });

    fetchMore({ offset: nextOffset, loadingTarget: 'button', shouldMergeResults: true });
  };

  return <Component {...props} onPaginationClick={onPaginationClick} />;
};

export default compose(withMetrics, withQnAPagination);
